import React from 'react'
import { useTranslation } from 'react-i18next';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import Menu from './../../../styled-base/menu';
import BoardConst from '../../utils/constants/board';

interface IHeaderMenuProps
{
    onAutomation?: any
    onDelete?: any
    columnType?: any
}
export default function ColumnHeaderMenu(props: IHeaderMenuProps) {
  const { t } = useTranslation();
  return (
    <Menu
    kebabColor="#FFFFFF"
    kebabSize="24px"
    isBottom={true}
    fixedWidth="160px"
    >
      { props.columnType != BoardConst.BOARD_DATATYPE_FREETEXT &&
        <Menu.Item disabled={false} onClick={() => props.onAutomation()}>
          <div className='board-automation-icon'></div>
          <span>{t('Automation')}</span>
        </Menu.Item>
      }
      
      <Menu.Item disabled={false} onClick={() => props.onDelete()}>
        <DeleteOutlinedIcon fontSize="small" htmlColor="#a6b6bc"/>
        <span>{t('Delete Column')}</span>
      </Menu.Item>
    </Menu>
  )
}
